import {
  FormFieldConfigType,
  INPUT_TYPES,
  RADIO_YES_NO,
} from "../../../../types";
import { CLAIM_VALIDATION_CONSTANTS } from "../../../constants";
import { preProcessFormFields } from "../../../../tools";

export const formFieldsConfig: FormFieldConfigType[] = [
  {
    name: CLAIM_VALIDATION_CONSTANTS.ALL_CLAIM_VALIDATION_FIELDS,
    type: INPUT_TYPES.FIELD_GROUP,
    contained: true,
    label: "Claim Validation",
    fields: [
      {
        name: CLAIM_VALIDATION_CONSTANTS.PRODUCT_CAUSED_INJURIES_OR_DAMAGES,
        label:
          "Is the claim involving a product that allegedly caused bodily injuries and/or property damages?",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: RADIO_YES_NO,
      },
      {
        name: CLAIM_VALIDATION_CONSTANTS.REQUESTING_ITEM_REMOVAL,
        label:
          "Is the claimant only requesting that the item be removed from sale?",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: RADIO_YES_NO,
      },
      {
        name: CLAIM_VALIDATION_CONSTANTS.SHARING_NEGATIVE_FEEDBACK,
        label: "Is the claimant only seeking to share their negative feedback?",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: RADIO_YES_NO,
      },
      {
        name: CLAIM_VALIDATION_CONSTANTS.REFUND_REQUEST_ONLY,
        label: "Is the claim related to a refund request only?",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: RADIO_YES_NO,
      },
      {
        name: CLAIM_VALIDATION_CONSTANTS.SEEKING_ADDITIONAL_COMPENSATION,
        label:
          "Is the claimant seeking additional compensation for their claim?",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: RADIO_YES_NO,
      },
      {
        name: CLAIM_VALIDATION_CONSTANTS.DELIVERY_ISSUE_RELATED,
        label: "Is the claim related to a delivery issue?",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: RADIO_YES_NO,
      },
    ],
  },
];

export const formFieldsConfigProcessed = preProcessFormFields(formFieldsConfig);
